import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { usePathname } from 'next/navigation';
import FullWidthContainer from 'components/consumer/FullWidthContainer';
import LogoLink from 'components/consumer/LogoLink';
import HeaderToolbar from 'components/nav/shared/HeaderToolbar';
import ConsumerSearchBar from 'components/consumer/consumer-search/ConsumerSearchBar';
import BrowserOnly from 'components/consumer/BrowserOnly';
import DesktopNavCategories from '../DesktopNavCategories';
const DesktopPrimaryNav = t0 => {
  const $ = _c(13);
  const {
    selectedCategoryId,
    setIsLinkHovered
  } = t0;
  const pathname = usePathname();
  const reserveDesktopSearch = pathname !== "/search" && pathname !== "/search/";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LogoLink />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== selectedCategoryId || $[2] !== setIsLinkHovered) {
    t2 = <DesktopNavCategories selectedCategoryId={selectedCategoryId} setIsLinkHovered={setIsLinkHovered} />;
    $[1] = selectedCategoryId;
    $[2] = setIsLinkHovered;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <HeaderToolbar />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <FullWidthContainer className="items-center flex justify-between max-[1023px]:z-11 lg:!z-[1003] relative bg-white" data-xc="DesktopPrimaryNav" hasPadding={true}>{t1}{t2}{t3}</FullWidthContainer>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = reserveDesktopSearch ? "min-h-[66px]" : undefined;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <BrowserOnly><ConsumerSearchBar /></BrowserOnly>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5) {
    t7 = <FullWidthContainer className={t5} data-xc="desktop-search-reservation">{t6}</FullWidthContainer>;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t7) {
    t8 = <FullWidthContainer>{t4}{t7}</FullWidthContainer>;
    $[10] = t4;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
DesktopPrimaryNav.propTypes = {
  selectedCategoryId: PropTypes.string,
  setIsLinkHovered: PropTypes.func
};
export default DesktopPrimaryNav;